<div class="auth">
  <header class="auth-header">
    <img src="assets/images/logo.png" alt="SipSignal Efax Logo" class="auth-header-logo" />
  </header>

  <main class="auth-main">
    <h1 class="h2">Sign up</h1>

    <form [formGroup]="form" class="auth-form" (ngSubmit)="register()">
      <input formControlName="login" placeholder="Nickname" class="form-input_lg" />

      <input formControlName="email" type="email" placeholder="E-mail" class="form-input_lg" />

      <div class="form-input-wrapper">
        <input
          formControlName="password"
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="Password"
          class="form-input_lg"
        />

        <button type="button" class="form-input-button">
          <img
            [src]="isPasswordVisible ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
            alt="Toggle password visibility"
            class="form-input-icon"
            (click)="togglePasswordVisibility()"
          />
        </button>
      </div>

      <p *ngIf="form.get('password').touched && form.get('password').errors?.['pattern']" class="form-error">
        {{ passwordErrorMessage }}
      </p>

      <div class="form-input-wrapper">
        <input
          formControlName="repeatPassword"
          [type]="isRepeatPasswordVisible ? 'text' : 'password'"
          placeholder="Repeat password"
          class="form-input_lg"
        />

        <button type="button" class="form-input-button">
          <img
            [src]="isRepeatPasswordVisible ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
            alt="Toggle repeat password visibility"
            class="form-input-icon"
            (click)="toggleRepeatPasswordVisibility()"
          />
        </button>
      </div>

      <p *ngIf="form.get('repeatPassword').touched && form.errors?.['passwordsMismatch']" class="form-error">
        Passwords do not match
      </p>

      <label class="auth-form-terms">
        <input formControlName="agreedToTerms" type="checkbox" class="auth-form-terms-checkbox" />
        <span class="auth-form-terms-text">
          I agree to the terms of the
          <a routerLink="/privacy" class="link auth-form-terms-link">Privacy Policy and Cookie Policy</a>
        </span>
      </label>

      <button type="submit" [disabled]="form.invalid" class="btn_primary btn_lg auth-form-submit-button">
        Register
      </button>

      <p *ngIf="isSignUpError" class="form-error">{{ signUpErrorMessage }}</p>

      <a routerLink="/auth" class="link auth-form-login-link">Login</a>
    </form>
  </main>
</div>
